import { getCurrentContent } from '../getCurrentContent';

const mergeCustomExtras = ({ customExtras, customExtrasUGCs }) => customExtras.map((customExtra, index) => ({
    ...customExtra,
    ...customExtrasUGCs[index] || {}
}));

export const mergePackageUGCs = ({ packageList, ugc }) => {
    const { packages: packageUGCS } = getCurrentContent({ ugc });

    return packageList.map((pkg) => {
        const { id, customExtras } = pkg;
        const { description, customExtras: customExtrasUGCs, title } = packageUGCS[id];

        return {
            ...pkg,
            title,
            description,
            customExtras: mergeCustomExtras({ customExtras, customExtrasUGCs })
        };
    });
};
